import { FaCrown } from 'react-icons/fa';
import { Avatar, Tooltip } from 'components/common';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from 'redux/authSlice';

// Tailwind replacements for falcon `.dropdown-item` / `.dropdown-divider`
const itemClass =
  'tw-block tw-w-full tw-px-4 tw-py-1.5 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-slate-100 hover:tw-text-slate-900 tw-no-underline tw-cursor-pointer tw-transition-colors';
const dividerClass =
  'tw-my-2 tw-border-0 tw-border-t tw-border-solid tw-border-slate-200';

/**
 * User menu. Local popover (trigger + absolutely-positioned panel +
 * outside-click/Escape close) with pure tailwind panel styling.
 */
const ProfileDropdown = () => {
  const {data: user} = useSelector(state => state.profile_user);
  const avartaName = (user?.name || '').substring(0, 3);
  const employeeName = [user?.employee?.first_name, user?.employee?.last_name].filter(Boolean).join(' ');
  const displayName = user?.full_name || employeeName || user?.name || 'User';
  const email = user?.email || user?.employee?.email;
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const handleLogOut = () => {
    dispatch(logout());
  }

  return (
    <li className="tw-relative tw-list-none" ref={rootRef}>
      <Tooltip
        placement="left"
        delay={150}
        content={open ? null : (
          <span className="tw-flex tw-flex-col tw-items-start tw-gap-0.5">
            <span className="tw-font-semibold">{displayName}</span>
            {email && <span className="tw-font-normal tw-text-slate-300">{email}</span>}
          </span>
        )}
      >
        <Link
          to="#"
          className="tw-flex tw-items-center tw-pl-2 tw-pr-0 tw-py-1 tw-no-underline"
          aria-label={`${displayName}${email ? `, ${email}` : ''}`}
          aria-expanded={open}
          onClick={(e) => {
            e.preventDefault();
            setOpen((prev) => !prev);
          }}
        >
          {user?.avatar_url ? <Avatar src={user?.avatar_url} size="sm" />  : <Avatar name={avartaName} size="sm" />}
        </Link>
      </Tooltip>

      {open && (
        <div className="tw-absolute tw-right-0 tw-top-full tw-mt-2 tw-min-w-[12rem] tw-bg-white tw-rounded tw-shadow-xl tw-border tw-border-solid tw-border-slate-200 tw-z-[1050]">
          <div className="tw-bg-white tw-rounded tw-py-2">
            <a className={`${itemClass} tw-font-bold tw-text-amber-500 hover:tw-text-amber-600`} href="#">
              <FaCrown className="tw-mr-1" />
              <span>Welcome {user?.name}</span>
            </a>
            <hr className={dividerClass} />

            <Link
              className={itemClass}
              to="/user/profile"
              onClick={() => setOpen(false)}
            >
              Profile &amp; account
            </Link>

            <hr className={dividerClass} />
            <Link
              className={itemClass}
              onClick={handleLogOut}
              to="/authentication/login"
            >
              Logout
            </Link>
          </div>
        </div>
      )}
    </li>
  );
};

export default ProfileDropdown;
